var _defs, _path, _path2, _circle, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUae = function SvgUae(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "uae_svg__Layer_1",
    viewBox: "0 0 1500 740"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".uae_svg__cls-6{stroke-width:0;fill:#fff}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    strokeWidth: 0,
    d: "M1069.21 300.27h-83.6c-7.18 0-13 5.82-13 13 0 3.7 1.55 7.03 4.03 9.4l-47.03 53.29a2.94 2.94 0 0 0-1.5-.42 2.97 2.97 0 1 0 2.97 2.97c0-.73-.27-1.38-.71-1.9l47.02-53.27c2.24 1.83 5.1 2.94 8.22 2.94h83.6c7.18 0 13-5.82 13-13s-5.82-13-13-13Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1033.92 314.38a1.924 1.924 0 0 1-1.94 1.95c-.36 0-.67-.09-.95-.26-.29-.18-.51-.41-.68-.7s-.25-.62-.25-.99v-5.55h-1.98v5.67c0 .69.17 1.31.5 1.86s.79.98 1.37 1.29 1.24.47 1.99.47 1.39-.16 1.98-.47 1.04-.74 1.37-1.29.5-1.17.5-1.86v-5.67h-1.92v5.55Zm6.34-5.54-3.6 9.19h1.94l.73-1.93h3.53l.72 1.93h2.02l-3.58-9.19zm-.33 5.67.52-1.39c.07-.2.14-.41.22-.62s.15-.43.22-.65.14-.44.2-.65c.06.21.13.42.2.65.08.25.16.48.23.7s.14.4.19.54l.54 1.43h-2.33Zm8.74 1.79v-2.12h3.67v-1.68h-3.67v-1.93h4.3v-1.73h-6.21v9.19h6.3v-1.73z",
    className: "uae_svg__cls-6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1011.76,
    cy: 313.27,
    r: 10,
    className: "uae_svg__cls-6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    strokeWidth: 0,
    d: "M1020.24 310.27h-12.7v6h12.7c.33-.94.52-1.95.52-3s-.19-2.06-.52-3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#31ab45",
    strokeWidth: 0,
    d: "M1020.24 310.27c-1.24-3.49-4.56-6-8.48-6-1.53 0-2.96.39-4.22 1.06v4.94z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d1d1d",
    strokeWidth: 0,
    d: "M1007.54 321.21a8.95 8.95 0 0 0 4.22 1.06c3.92 0 7.24-2.51 8.48-6h-12.7z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#e92a2c",
    strokeWidth: 0,
    d: "M1003.29 310.27c-.33.94-.52 1.95-.52 3s.19 2.06.52 3a9.03 9.03 0 0 0 4.25 4.94v-15.88a9 9 0 0 0-4.25 4.94"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0,
    d: "M0 0h1500v740H0z"
  })));
};
export default SvgUae;